module.exports = __webpack_public_path__ + "img/logo.c9d9d70b.png";